import { isTauri } from '@/tauri/utils';
import { setActiveWorkspace } from '@/tauri/workspace';
import { logger } from '@/utils/logger/logger';
import { useWorkspaceId } from '@heidi/workspace/data';
import { useEffect } from 'react';

/**
 * Mirrors the active workspace into Rust so Rust-initiated backend requests
 * (session creation engine, Chronicle auto-session, live uploads) can stamp
 * `Heidi-Workspace-Id` — those clients bypass the web axios interceptor.
 * Subscribing to the atom covers every writer: boot hydration, invitation
 * acceptance, onboarding, and the manual switcher.
 */
export function useSyncActiveWorkspaceToDesktop(): void {
  const workspaceId = useWorkspaceId();

  useEffect(() => {
    if (!isTauri()) return;
    // A failed push means Rust keeps stamping a stale (or no) workspace on
    // session/upload requests — silent misattribution, so it must be visible.
    setActiveWorkspace(workspaceId).catch((error) => {
      logger.warn({
        msg: '[workspace_header] Failed to push active workspace to Rust',
        workspaceId,
        error: error instanceof Error ? error.message : String(error),
      });
    });
  }, [workspaceId]);
}
